import * as actionTypes from '../actionTypes';
export function getTeachAndStudent(data) {
	return {
		type: actionTypes.GET_TEACHER_AND_SUBJECT_FILTER,
		payload: data
	};
}
//new code repo
// changes for time-table
